import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
export const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="w-full bg-white py-6 border-b border-gray-100" data-id="element-82">
      <div className="container mx-auto px-6 flex justify-between items-center" data-id="element-83">
        <div data-id="element-84">
          <div className="font-bold text-2xl text-gray-900" data-id="element-85">Sandor Moricz</div>
          <div className="text-sm text-gray-500" data-id="element-86">
            Product Manager | Strategy & Execution
          </div>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-10" data-id="element-87">
          <a href="#home" className="text-gray-600 hover:text-gray-900 font-medium text-sm uppercase tracking-wider" data-id="element-88">
            Home
          </a>
          <a href="#services" className="text-gray-600 hover:text-gray-900 font-medium text-sm uppercase tracking-wider" data-id="element-89">
            Services
          </a>
          <a href="#contact" className="text-gray-600 hover:text-gray-900 font-medium text-sm uppercase tracking-wider" data-id="element-90">
            Contact
          </a>
        </nav>
        {/* Mobile menu button */}
        <button className="md:hidden text-gray-700" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-91">
          {isMenuOpen ? <X size={24} data-id="element-92" /> : <Menu size={24} data-id="element-93" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white py-4 px-6" style={{
      animation: 'slideDown 0.25s ease-out'
    }} data-id="element-94">
          <nav className="flex flex-col space-y-6" data-id="element-95">
            <a href="#home" className="text-gray-600 hover:text-gray-900 font-medium text-sm uppercase tracking-wider" onClick={() => setIsMenuOpen(false)} data-id="element-96">
              Home
            </a>
            <a href="#services" className="text-gray-600 hover:text-gray-900 font-medium text-sm uppercase tracking-wider" onClick={() => setIsMenuOpen(false)} data-id="element-97">
              Services
            </a>
            <a href="#contact" className="text-gray-600 hover:text-gray-900 font-medium text-sm uppercase tracking-wider" onClick={() => setIsMenuOpen(false)} data-id="element-98">
              Contact
            </a>
          </nav>
        </div>}
      {/* Animation styles */}
      <style jsx data-id="element-99">{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </header>;
};